
import { Component, Vue } from "vue-property-decorator";
import General from "@/components/portal/client/configuration/users/updateUser/UpdateUser.vue";
import Uploader from "@/views/uploader/Uploader.vue";

@Component({ components: { General, Uploader } })
export default class AddClientComponent extends Vue {
  public tabLinks = [
    { name: "General", value: "general", class: "active" },
    {
      name: "Upload Pan & Adhar Card",
      value: "uploadPanAndAdhar",
      class: "",
    },
  ];
  public nextTab: any = null;
  public index: any = null;
  public userId = null;

  public get currentTab() {
    return this.$store.state.currentTab;
  }
  cancelForm() {
    localStorage.removeItem("temporaryData");
    this.$router.go(-1);
  }

  /*********************************************************************************
   *    Change Active tab                                                         *
   *********************************************************************************/
  public async goToTab(value, leave) {
      if (leave) {
        this.tabLinks.forEach(async (tab, tabIndex) => {
          if (tab.value == value) {
            tab.class = "active";
            await this.$store.dispatch("updateStore", { currentTab: value });
          } else {
            tab.class = "";
          }
        });
      }
  }

  /*****************************************************************************************************
   *            Save every tab information on tab switch                                              *
   ****************************************************************************************************/
  public async saveEveryTabInformation(tabName) {
      if (tabName && this.$refs[tabName])
        return await this.$refs[tabName]["saveInformation"]();
  }

  /***************************************************************************************
   *              Change tab on click or validate existing tab data.                     *
   ***************************************************************************************/
  public async tabChange(value) {
    if (value != this.currentTab) {
      let data = await this.saveEveryTabInformation(this.currentTab);
      if (data.status) {
        this.goToTab(value, true);
      }
    }
  }

  async mounted() {
    await this.$store.dispatch("getUserById", { userId: this.$userId });
    await this.goToTab(this.currentTab, true);
  }

  destroyed() {
    this.$store.dispatch("cancelUserForm");
  }
}
